<app-search></app-search>
<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Lista de {{ termKey.ActivityServicePlural | term }}</h1>
    </div>
    <br />
    <div class="card-header">
      <button
        id=""
        class="primary-button"
        appPermision="/serviceactivity+c"
        (click)="createServiceActivity()"
      >
        <span class="button-content"> <mat-icon>add_circle</mat-icon> Agregar nuevo </span>
      </button>
    </div>
    <br />
    <div class="table-scroll-wrapper">
      <section class="table-container mat-elevation-z1" tabindex="0">
        <div class="table-adjustable">
          <table
            mat-table
            [dataSource]="
              (asyncserviceactivity | async) ?? []
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: limit,
                      currentPage: page,
                      totalItems: total,
                    }
            "
          >
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let serviceActivity">
                <div class="action-buttons">
                  <a
                    title="Editar"
                    class="icon-button"
                    appPermision="/serviceactivity+u"
                    (click)="updateServiceActivity(serviceActivity)"
                  >
                    <span class="material-symbols-outlined"><mat-icon>edit</mat-icon></span>
                  </a>
                  <a
                    title="Eliminar"
                    appOnlysuperuser="/serviceactivity"
                    (click)="eliminate(serviceActivity)"
                    class="icon-button"
                  >
                    <span class="material-symbols-outlined"><mat-icon>delete</mat-icon></span>
                  </a>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let serviceActivity">
                {{ serviceActivity.id }}
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Nombre</th>
              <td mat-cell *matCellDef="let serviceActivity">
                {{ serviceActivity.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef>Descripción</th>
              <td mat-cell *matCellDef="let serviceActivity">
                {{ serviceActivity.description }}
              </td>
            </ng-container>

            <ng-container matColumnDef="month">
              <th mat-header-cell *matHeaderCellDef>Mes</th>
              <td mat-cell *matCellDef="let serviceActivity">
                {{ serviceActivity.month }}
              </td>
            </ng-container>

            <ng-container matColumnDef="consumableAssets">
              <th mat-header-cell *matHeaderCellDef>Insumos</th>

              <td mat-cell *matCellDef="let serviceactivity">
                @if (serviceactivity.consumableAssets?.length) {
                  <ul class="m-0 ps-3">
                    @for (asset of serviceactivity.consumableAssets; track asset.id) {
                      @for (ca of asset.consumableAsset; track ca.id) {
                        <li>
                          {{ ca.name }}
                          ({{ asset.expense?.qty }} {{ asset.expense?.unity }})
                        </li>
                      }
                    }
                  </ul>
                } @else {
                  <span>No registra</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="locations">
              <th mat-header-cell *matHeaderCellDef>Ubicación</th>

              <td mat-cell *matCellDef="let serviceActivity">
                @if (serviceActivity.locations?.length) {
                  <ul>
                    @for (lo of serviceActivity.locations; track lo) {
                      <li>{{ lo.city }} - {{ lo.department }}</li>
                    }
                  </ul>
                } @else {
                  <span>No registra</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="adress">
              <th mat-header-cell *matHeaderCellDef>Dirección</th>
              <td mat-cell *matCellDef="let serviceActivity">
                {{ serviceActivity.adress?.street }} - {{ serviceActivity.address?.territory }}
              </td>
            </ng-container>

            <ng-container matColumnDef="line">
              <th mat-header-cell *matHeaderCellDef>Línea</th>
              <td mat-cell *matCellDef="let serviceActivity">
                {{ serviceActivity.line?.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="total">
              <th mat-header-cell *matHeaderCellDef>Total</th>
              <td mat-cell *matCellDef="let serviceActivity">
                {{ serviceActivity.total }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: showColumns" class="highlight-row"></tr>
          </table>
        </div>
      </section>
    </div>
    <pagination-controls
      (pageChange)="fetchServiceActivities($event)"
      previousLabel="Anterior"
      nextLabel="Siguiente"
      id="server"
    ></pagination-controls>
  </div>
</div>
